import React, { useEffect, useState } from "react";
import UiContent from "../../Components/Common/UiContent";
import { Col, Container, Row } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import CustomDatePicker from "../../Components/Common/CustomDatePicker";
import Select, { components } from "react-select";
import { useSelector } from "react-redux";
import CheckListingItems from "./CheckListing";


const CheckListing = () => {
    const [leftCustomDate, setLeftCustomDate] = useState([]);
    const [mealPeriod, setMealPeriod] = useState([]);
    const [filtermealperiod, setFiltermealperiod] = useState([]);
    const [selectedMealList, setSelectedMealList] = useState(null);
    const [refresh, setRefresh] = useState(false);
    const [serveList, setserveList] = useState([]);
    const [currency, setCurrency] = useState("$");
    const [selectedServeList, setSelectedServeList] = useState(null);
    const [filterserveList, setFilterserveList] = useState([]);
    const changeServerList = (value) => {
        setSelectedServeList(value);
        let selVal = [];
        value.forEach((item) => {
            selVal.push(item.value);
        });
        setserveList(selVal);
    };
    const [leftFilter, setLeftFilter] = useState({
        label: "Yesterday",
        value: "Yesterday",
    });
    const { currentOutlet } = useSelector((state) => ({
        currentOutlet: state.UserOutletGroup.currentOutlet,
    }));
    const { filterData, filterAjax, } = useSelector((state) => ({
        filterData: state.Dashboard.filterData,
        filterAjax: state.Dashboard.filterAjax,
    }));


    const handleRefresh = () => {
        setRefresh(!refresh);
    }

    useEffect(() => {
        if (currentOutlet?.currency !== "") {
            setCurrency(currentOutlet?.currency);
        }
    }, [currentOutlet]);

    const changeMealPeriod = (value) => {
        setSelectedMealList(value);
        let selVal = [];
        value.forEach((item) => {
            selVal.push(item.value);
        });
        setMealPeriod(selVal);
    };


    useEffect(() => {
        // localStorage.setItem('Singleitem_SortType', '');
        localStorage.setItem('discunt_check_listing_SortType', '');

        if (filterData.serverList) {
            setFilterserveList(filterData.serverList);
        }
        if (filterData.mealperiod) {
            const mealListArr = [];
            filterData.mealperiod.forEach((item) => {
                mealListArr.push({
                    value: item.sp_id,
                    label: item.title + ' (' + item.start_time + ' To ' + item.end_time + ')'
                });
            });

            setFiltermealperiod(mealListArr);
        }
        if (filterData.flash_date) {
            setLeftFilter(
                (prev) => prev || filterData.flash_date.find((date) => date.default)
            );
        }
    }, [filterAjax, filterData]);



    const CustomOption = (props) => {
        return (
            <components.Option {...props}>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <input type="checkbox" checked={props.isSelected} onChange={() => null} style={{ verticalAlign: "middle" }} />
                    <span style={{ verticalAlign: "middle", lineHeight: 1 }}>{props.data.label}</span >
                </div>
            </components.Option>
        );
    };

    return (
        <React.Fragment>
            <UiContent />
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Check Listings" pageTitle="Dashboard" customDate={leftCustomDate} handleRefresh={handleRefresh} />

                    <form className="mb-3">
                        <Row>

                            <Col className="mb-2 mb-lg-0 p-0" sm={12} lg={4}>
                                <CustomDatePicker
                                    activeDate={leftFilter}
                                    setActiveDate={setLeftFilter}
                                    customDate={leftCustomDate}
                                    setCustomDate={setLeftCustomDate}
                                    posEnd={false}
                                />
                            </Col>
                            <Col className="mb-2 mb-lg-0" sm={12} lg={4}>
                                <Select
                                    value={selectedMealList}
                                    isMulti={true}
                                    onChange={(value) => {
                                        changeMealPeriod(value);
                                    }}
                                    options={filtermealperiod}
                                    placeholder="All Meal Periods"
                                    closeMenuOnSelect={false}
                                    components={{ Option: CustomOption }}
                                />
                            </Col>
                            <Col className="mb-2 mb-lg-0" sm={12} lg={4}>
                                <Select
                                    value={selectedServeList}
                                    isMulti={true}
                                    onChange={(value) => {
                                        changeServerList(value);
                                    }}
                                    options={filterserveList}
                                    placeholder="All servers"
                                    components={{ Option: CustomOption }}
                                />
                            </Col>
                        </Row>
                    </form>

                    <Row className="gx-4 gy-0">
                        <CheckListingItems
                            currency={currency}
                            activeDate={leftFilter}
                            customDate={leftCustomDate}
                            mealPeriod={mealPeriod}
                            serveList={serveList}
                        />
                    </Row>

                </Container>
            </div>
        </React.Fragment>
    )

}

export default CheckListing;